import {getWb} from 'utils/serviceWorker/registerServiceWorker';

let currentVersion: string | null = localStorage.getItem('app_version');
let onVersionMismatch: (() => void) | null = null;

export function subscribeToVersionChange(callback: () => void) {
    onVersionMismatch = callback;
}

export async function checkVersion() {
    console.log('checkVersion', currentVersion);
    try {
        const response = await fetch('/version.json', {cache: 'no-store'});
        const version = await response.text();

        if (currentVersion && currentVersion !== version) {
            console.log('[checkVersion] Новая версия найдена');
            localStorage.setItem('app_version', version);
            const wb = getWb();
            if (!wb) return;
            wb.addEventListener('controlling', () => {
                window.location.reload();
            });

            wb.messageSkipWaiting();
            onVersionMismatch?.(); // триггерим внешнюю логику
        }

        currentVersion = version;
    } catch (error) {
        console.error('[checkVersion] Ошибка при проверке версии:', error);
    }
}
